var React = require('react');
var createReactClass = require('create-react-class');
var DateFormat = require('../../../components/dateFormat.jsx');

var TrialListItem = createReactClass({
	render: function(){
		const {
			NCTNumber, studyTitle, briefSummary,
			startDate, gender, age, studyType,
			conditions, primaryOutcomes, locations,
		} = this.props.trialData;
		const url = `https://ClinicalTrials.gov/show/${NCTNumber}`;
		const conditionsList = conditions.map((condition) => { return condition }).join(', ')
		const primaryOutcomesList = (
			<ul>
				{ primaryOutcomes.map((primaryOutcome, index) => { return <li key={index}>{primaryOutcome}</li> }) }
			</ul>
		);
		const locationList = (
			<ul>
				{ locations.map((location, index) => { return <li key={index}>{location}</li> }) }
			</ul>
		);

		return (
			<div>
				<h1>
					<a target="_trial" href={url}>{studyTitle}</a>
				</h1>
				<p>{briefSummary}</p>
				<table>
					<thead>
						<tr>
							<th width="100">Start date</th>
							<th width="100">Gender</th>
							<th width="200">Ages</th>
							<th width="200">Study type</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td><DateFormat date={startDate} format="MMM DD, YYYY" /></td>
							<td>{gender}</td>
							<td>{age}</td>
							<td>{studyType}</td>
						</tr>
					</tbody>
				</table>
				<p>
					<strong>Conditions: </strong><br />
					<span>{conditionsList}</span>
				</p>
				<div>
					<strong>Primary outcomes:</strong><br />
					{primaryOutcomesList}
				</div>
				<div>
					<strong>Locations:</strong><br />
					{locationList}
				</div>
				<p>
					<strong>More info:</strong><br />
					<span><a target="_trial" href={url}>{url}</a></span>
				</p>
				<hr />
			</div>
	  )
	}
});

module.exports = TrialListItem;



// WEBPACK FOOTER //
// ./src/common/routes/trials/components/layout/trialListItem.jsx